
let reduxStore = null;

export const setStoreRef = store => {
    reduxStore = store;
};

export const getStoreRef = () => {
    return reduxStore;
};

export const resetStoreRef = () => {
    reduxStore = null;
};

export default {
    getStoreRef,
    setStoreRef,
    resetStoreRef,
};
